module.exports = __webpack_public_path__ + "img/Geisha Assasin Esport Logo.jpg";